import { render, staticRenderFns } from "./ChangeLogDetail.vue?vue&type=template&id=7629fc93&"
import script from "./ChangeLogDetail.vue?vue&type=script&lang=ts&"
export * from "./ChangeLogDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports